import $ from 'jquery';

$(function() {
  let count = 0;
  let limit = 4;
  let text = '';
  let text1 = '';
  let text2 = '';
  let text3 = '';
  let data;
  let graph_api = 'https://graph.facebook.com/v16.0/';
  let accessToken = 'EAAWQkqtON6sBAHQ5g7d9wZAAB6Mn2jRiBl9gf5qsHZBLP5Uw1YVNHXeWXAPDwdwJNqg4h8V3PeHRNbZC2z4nZAqoEJvi9IZCmC1RBRwZCfkrbR1SX1pdZCPMAIbJyx2EbO1m4H9y3aQwj0dYay4CdbRVuPYr4oZAgN2ocVg5bnSYZAg14GK993DTFUmghjL5rn0z9YbbHZBZCnr0AZDZD';
  let businessID = '17841408102427974';
  let fields = 'media{media_url,thumbnail_url,permalink}';
  let url = graph_api + businessID + '?fields=' + fields + "&access_token=" + accessToken;
  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json',
  })
  .done(function(res) {
    data = res.media;
    count = 0;

    $.each(data, function(index, val) {
      $.each(val, function(i, elem) {
        if (elem.thumbnail_url && count < limit) {
          text1 = '<li><a href="'+elem.permalink+'" target="_blank" class="p-top-instagram__item">';
          text2 = '<img src="'+elem.thumbnail_url+'" alt="" loading="lazy" width="230" height="230">';
          text3 = '</a></li>';
          count ++;
          text = text + text1 + text2 + text3;
        } else if (elem.media_url && count < limit) {
          text1 = '<li><a href="'+elem.permalink+'" target="_blank" class="p-top-instagram__item">';
          text2 = '<img src="'+elem.media_url+'" alt="" loading="lazy" width="230" height="230">';
          text3 = '</a></li>';
          count ++;
          text = text + text1 + text2 + text3;
        }
      });
    });
    
  $('#js-instagram').append(text);
  })
  .fail(function(jqXHR, status) {
    $('#js-instagram').append('<li>読み込みに失敗しました。</li>');
  })
});